import { Link } from "react-router-dom";
import { useTenant } from "../../../Contexts/TenantContext";
import { PolicyType } from "../../../Enums/PolicyType";
import SmartNavbar from "../../../Components/SmartNavbar/SmartNavbar";
import Banner from "../../../Components/Banner/Banner";
import PoliciesLinks from "../../../Components/PoliciesLinks/PoliciesLinks";
import PolicyAccordionItem from "../../../Components/PolicyAccordionItem/PolicyAccordionItem";
import Footer from "../../../Components/Footer/Footer";

const UserCookiesPoliciesPage = () => {
  const { tenant, tenantContact } = useTenant();

  return (
    <div>
      <SmartNavbar />
      <div className={`w-full bg-gray-50`}>
        <Banner 
          title="Políticas de Cookies" 
          description="Quando você compra em nossa plataforma você nos confia seus dados pessoais. É pensando na manutenção desta confiança que criamos nossas Políticas de Privacidade e Proteção de Dados Pessoais. Aqui é possível entender as nossas práticas sobre o tratamento dos seus dados."
        />
        <div className={`w-full flex flex-col md:flex-row gap-4 md:gap-6 page-gutter py-6 xl:px-36`}>
          {/* Mobile policies on top */}
          <div className="flex md:hidden justify-between mb-4">
            <PoliciesLinks excludedPolicy={PolicyType.CookiesPolicies} isMobile />
          </div>

          {/* Desktop sidebar */}
          <div className={`hidden md:block flex-[0.4] `}>
            <PoliciesLinks excludedPolicy={PolicyType.CookiesPolicies} />
          </div>

          {/* Accordion items */}       
          <div className={`flex flex-col flex-[1.6] gap-2 md:gap-4 `}>
            <PolicyAccordionItem
              title="O que são Cookies?"
              content={
                <div className="text-xs text-gray-800 leading-normal md:text-justify">
                  <p className="mb-5">Os cookies são pequenos arquivos enviados pelos sites durante a navegação. Eles ficam armazenados nos dispositivos de computadores e dispositivos móveis, que permitem melhorar o desempenho e a experiência de navegação dos nossos clientes. A inserção de cookies auxilia no reconhecimento do dispositivo para a próxima visita, guardando apenas informações genéricas como a forma e/ou local de acesso e o modo como o cliente utiliza nossa plataforma (e-commerce).</p>

                  <p>Nós utilizamos Cookies primários, os quais são adicionados diretamente nos dispositivos pela nossa plataforma. Os cookies possuem tempo de vida, sendo os temporários expiram logo após o fechamento do navegador e os persistentes permanecem no seu dispositivo por tempo determinado ou até que seja feita a exclusão manual.</p>
                </div>
              }
            />

            <PolicyAccordionItem
              title="Tipos de Cookies que utilizamos"
              content={
                <div className="text-xs text-gray-800 leading-normal md:text-justify">
                  <p className="mb-1">Cookies necessários</p>    
                  <p>Como o próprio nome diz, são os necessários para o funcionamento das nossas plataformas. Portanto, os clientes que desabilitarem os cookies em seus navegadores poderão não ter a melhor experiência durante a navegação, incluindo o comprometimento de funcionalidades essenciais.</p>
                </div>
              }
            />

            <PolicyAccordionItem
              title="Como você pode gerenciar os cookies em seu navegador?"
              content={
                <div className="text-xs leading-normal md:text-justify">
                  <p className="text-gray-800 mb-5">É possível bloquear tipos específicos de cookies por meio das configurações do navegador utilizado. A grande maioria dos navegadores aceita cookies automaticamente, portanto cabe ao usuário personalizar o seu próprio navegador. Para mais detalhes sobre como apagar ou rejeitar cookies, há tutoriais que tratam do assunto:</p>
                  <ul className="list-item text-primary-600 space-y-1">
                    <li>
                      <Link 
                        to="https://support.google.com/chrome/answer/95647?hl=pt-BR"
                      >
                        Google Chrome
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="https://support.apple.com/pt-br/guide/safari/sfri11471/mac"
                      >
                        Safari
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="https://help.opera.com/en/latest/web-preferences/#cookies"
                      >
                        Opera
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="https://support.microsoft.com/pt-br/windows/gerencie-cookies-no-microsoft-edge-exibir-permitir-bloquear-excluir-e-usar-168dab11-0753-043d-7c16-ede5947fc64d"
                      >
                        Microsoft Edge
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="https://support.mozilla.org/pt-BR/kb/gerencie-configuracoes-de-armazenamento-local-de-s"
                      >
                        Mozilla Firefox
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="https://support.microsoft.com/pt-br/windows/gerencie-cookies-no-microsoft-edge-exibir-permitir-bloquear-excluir-e-usar-168dab11-0753-043d-7c16-ede5947fc64d"
                      >
                        Internet Explorer
                      </Link>
                    </li> 
                  </ul>
                </div>
              }
            />

            <div className="text-xs text-gray-800 leading-normal md:text-justify">
              <p className="mb-5">Quando mudarmos a forma de tratamento de dados pessoais esta Política será atualizada, por esse motivo recomendamos que acesse esta política com frequência e em caso de dúvidas, procure-nos em nossa Central de Atendimento.</p>
              <p className="mb-5">
                Dúvidas, comentários e reclamações sobre as práticas de tratamento de dados da {tenant?.companyName} podem ser enviados no email 
                <Link
                  to=""
                  className="text-primary-600 ml-1"
                >
                  {tenantContact?.email}
                </Link>.
              </p>
              <p>
                Exerça seus Direitos de Privacidade 
                <Link 
                  to="/portal-privacidade"
                  className="text-primary-600 ml-1"
                >
                  clicando aqui
                </Link>.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UserCookiesPoliciesPage;
